import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SurveyFeedbackHomeComponent } from './home/survey-feedback-home.component';

const routes: Routes = [
  { path: '', component: SurveyFeedbackHomeComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveyFeedbackRoutingModule { }
